"use strict";module.exports=e=>e.toLocaleLowerCase().trim().split(" ").join("-");
//# sourceMappingURL=index.js.map
